module.exports = __webpack_public_path__ + "img/637025817305109221slaapproblemen-overzicht.png";